import { AgentDesktopRouter } from '@agent/agent-interface/agent-desktop-router';
import { IAgentConfigDeprecatedService } from '@agent/core/agent/agent-config-deprecated.service';
import { ContactHistoryService } from '@agent/core/contact/history/contact-history.service';
import { ModalService } from '@commons/core/ui/modal/modal.service';
import { Store } from '@ngrx/store';
import { i18n } from 'i18next';

import { AgentChannelFacade, AgentUserFacade, ToasterFacade } from '@contact/upgrade';

import { BasketModel } from '../basket.model';
import { IBasketStore } from '../basket.store';
import { IMailBasketService } from '../mail/mail-basket.service';
import { IVisioBasketService } from '../visio/visio-basket.service';

export enum BasketCategoryType {
  COMMON = 'COMMON',
  DEDICATED_AGENT_UNASSIGNED = 'DEDICATED_AGENT_UNASSIGNED',
  DELEGATED = 'DELEGATED',
  DRAFT = 'DRAFT',
  PERSONAL = 'PERSONAL',
  PERSONAL_FOR_CSR = 'PERSONAL_FOR_CSR',
  SENT = 'SENT',
}

export type SortOrder = 'asc' | 'desc';

export interface Sort {
  defaultKey: string;
  key: string;
  order: SortOrder;
}

export interface BasketResult<T extends BasketModel = BasketModel> {
  // label use by request
  readonly label: string;
  // if query is filtered
  readonly filtered: boolean;
  // number of requests for query
  readonly nbRequests: number;
  // query result list
  readonly requests?: T[];
}

export interface SW {
  readonly basketStore: IBasketStore;
  readonly router: AgentDesktopRouter;
  readonly $i18next: i18n;
  readonly agentConfigDeprecatedService: IAgentConfigDeprecatedService;
  readonly mailBasketService: IMailBasketService;
  readonly visioBasketService: IVisioBasketService;
  readonly toasterFacade: ToasterFacade;
  readonly store$: Store;
  readonly agentUserFacade: AgentUserFacade;
  readonly agentChannelFacade: AgentChannelFacade;
  readonly modalService: ModalService;
  readonly contactHistoryService: ContactHistoryService;
}
